function TextBlock({ value }) {
    return <div className="max-w-full prose md:prose-lg lg:max-w-xl" dangerouslySetInnerHTML={{ __html: value }}></div>;
}

export default TextBlock;
